import {useSelector, shallowEqual} from 'react-redux';
import * as R from 'ramda';

export const useStoreSelector = useSelector;

export const useShallowPickSelector = (store, properties) =>
  useSelector((state) => R.pick(properties, state[store]), shallowEqual);

export const selectStore = (store) => (state) => state[store];

const Selectors = {
  selectStore,
  useShallowPickSelector,
  useStoreSelector,
};

export default Selectors;
